import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import { TIProcesseForm, iProcesseSchema } from "./iProcesseSchema";
import {
  FormContainer,
  FormInput,
  SwitchInput,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import {
  createIProcesse,
  getIProcesseById,
  updateIProcesseById,
} from "../../../../../services/iProcesse.service";

const translationPath = "page.4uBus.register.iProcesse.";

const IProcesse = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(createIProcesse);

  const { sendRequest: update, loading: uLoading } =
    useFetch(updateIProcesseById);

  const { sendRequest: get, loading: gLoading } = useFetch(getIProcesseById);

  const [code, setCode] = useState<number | null>(null);

  const saveHandler = (v: TIProcesseForm) =>
    save({
      ...v,
    });

  const updateHandler = (v: TIProcesseForm, id: string) =>
    update({
      item: {
        ...v,
      },
      id: id,
    });

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TIProcesseForm>> => {
      const { data, success } = await get(id);
      if (data && success) {
        const newData: TIProcesseForm = {
          ...data,
        };
        setCode(data.code);
        return { data: newData, success: true };
      }
      return { data, success: true };
    },
    [get],
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TIProcesseForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "i_processe")}
      schema={iProcesseSchema}
      subtitle={t(translationPath + "new_i_processe")}
      subtitleWatchField="name"
      fields={() => (
        <Grid container spacing={2}>
          {code && (
            <Grid item xs={12}>
              <Typography variant="body2" fontSize="1rem">
                {`${t(translationPath + "code")}: ${code}`}
              </Typography>
            </Grid>
          )}

          <Grid item xs={12} textAlign="end">
            <SwitchInput name="enable" label={t(translationPath + "enable")} />
          </Grid>

          <Grid item xs={12}>
            <FormInput
              size="small"
              name="name"
              label={t(translationPath + "processe_name")}
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <FormInput
              size="small"
              name="description"
              label={t(translationPath + "description")}
              multiline
              rows={4}
              fullWidth
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default IProcesse;
